'use strict';

var _regeneratorRuntime = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var from = require('from2');

var pIsPromise = require('p-is-promise');

var intoStream = function intoStream(input) {
  if (Array.isArray(input)) {
    input = input.slice();
  }

  var promise;
  var iterator;
  prepare(input);

  function prepare(value) {
    input = value;

    if (input instanceof ArrayBuffer || ArrayBuffer.isView(input) && !Buffer.isBuffer(input)) {
      input = Buffer.from(input);
    }

    promise = pIsPromise(input) ? input : null; // We don't iterate on strings and buffers since slicing them is ~7x faster

    var shouldIterate = !promise && input[Symbol.iterator] && typeof input !== 'string' && !Buffer.isBuffer(input);
    iterator = shouldIterate ? input[Symbol.iterator]() : null;
  }

  return from(function reader(size, callback) {
    var _this = this;

    if (promise) {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.t0 = prepare;
                _context.next = 4;
                return promise;

              case 4:
                _context.t1 = _context.sent;
                _context.next = 7;
                return (0, _context.t0)(_context.t1);

              case 7:
                reader.call(_this, size, callback);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t2 = _context["catch"](0);
                callback(_context.t2);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }))();

      return;
    }

    if (iterator) {
      var object = iterator.next();
      setImmediate(callback, null, object.done ? null : object.value);
      return;
    }

    if (input.length === 0) {
      setImmediate(callback, null, null);
      return;
    }

    var chunk = input.slice(0, size);
    input = input.slice(size);
    setImmediate(callback, null, chunk);
  });
};

module.exports = intoStream; // TODO: Remove this for the next major release

module.exports.default = intoStream;

module.exports.object = function (input) {
  if (Array.isArray(input)) {
    input = input.slice();
  }

  var promise;
  var iterator;
  prepare(input);

  function prepare(value) {
    input = value;
    promise = pIsPromise(input) ? input : null;
    iterator = !promise && input[Symbol.iterator] ? input[Symbol.iterator]() : null;
  }

  return from.obj(function reader(size, callback) {
    var _this2 = this;

    if (promise) {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.t0 = prepare;
                _context2.next = 4;
                return promise;

              case 4:
                _context2.t1 = _context2.sent;
                _context2.next = 7;
                return (0, _context2.t0)(_context2.t1);

              case 7:
                reader.call(_this2, size, callback);
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t2 = _context2["catch"](0);
                callback(_context2.t2);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }))();

      return;
    }

    if (iterator) {
      var object = iterator.next();
      setImmediate(callback, null, object.done ? null : object.value);
      return;
    }

    this.push(input);
    setImmediate(callback, null, null);
  });
};